// @flow

import React, { Component } from 'react';
import { connect }          from 'react-redux';
import { getTranslate }     from 'react-localize-redux';
import { clearAuthMsg }     from 'actions/session/authMsg';
import { unlockAccount, unlockAccountByToken } from 'actions/session/userAuth';
import AuthMsg              from '../authMsg/authMsg.js';
import validationHelper     from 'helpers/validation.helper';
import queryString          from 'query-string';
import './unlock.css';

class Unlock extends Component {

  state = {
    email       : '',
    emailValid  : false,
    formValid   : true
  };

  // Unlock token already sent to API, so the same token is never sent twice
  sentUnlockToken = null;

  // Component constructor
  constructor() {
    super();

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleChange = (e) => {
    //Save data to state
    const { id, value } = e.target;
    this.setState({ [id]: value });

    // Check for simple validation
    this.validateField(id, value);
  }

  handleSubmit = (e) => {
    e.preventDefault();

    const { email } = this.state;
    const { dispatch, history } = this.props;

    dispatch(clearAuthMsg());

    // Create unlock post
    dispatch(unlockAccount(email, history));
  }

  // Validate form
  validateField = (field, value) => {
    let emailValid = this.state.emailValid;

    switch(field) {
      case 'email':
        emailValid = validationHelper.email(value);
        break;
      default:
        break;
    }

    this.setState({ emailValid: emailValid });
  }

  componentDidMount() {
    this.checkTokenIfExists();
  }

  componentDidUpdate(prevProps) {
    // Router re-uses this component when only the query string changes
    const prevSearch = prevProps.location ? prevProps.location.search : '';
    const search = this.props.location ? this.props.location.search : '';
    if( prevSearch !== search ) {
      this.checkTokenIfExists();
    }
  }

  checkTokenIfExists = () => {
    const { dispatch, history, location } = this.props;
    const query_string = queryString.parse(location && location.search ? location.search : '');
    const unlock_token = query_string ? query_string.unlock_token : null;

    if( !unlock_token || unlock_token === this.sentUnlockToken ) return false;

    this.sentUnlockToken = unlock_token;
    dispatch(unlockAccountByToken(unlock_token, history));
    return true;
  }

  render() {

    const { email, emailValid } = this.state;
    const { translate } = this.props;

    return (
      <div className="unlock">
        <div>
          <div className="container">
            <div className="row">
              <div className="col-xs-12 col-sm-8 col-sm-offset-2 text-center">
                <div className="top-header">
                  <h2>{translate('session.unlock.title')}</h2>
                  <h4>{translate('session.unlock.title_slogan')}</h4>
                </div>
              </div>
            </div>
          </div>

          <div className="row main-content">
            <div className="col-xs-12 col-sm-8 col-sm-offset-2">
              <div className="row">
                <div className="col-xs-12">
                  <form name="form_unlock" className="login-form" onSubmit={this.handleSubmit}>
                    <div className="form-group has-float-label">
                      <input type="email" id="email" name="email" value={email} onChange={this.handleChange} className="form-control" autoFocus required />
                      <label>{translate('session.field.field_email')}</label>
                      <span className="email-icon" />
                      <span className={"validation-check " + (!emailValid ? 'uncheck' : '')}></span>
                    </div>
                    <AuthMsg provider='email'/>
                    <div className="form-group">
                      <div className="submit-wrap">
                        <div className="button-wrap">
                          <input type="submit" name="unlock" value={translate('session.unlock.button_send')} />
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>

          <div className="row bottom">
            <div className="col-xs-12 col-lg-3 margin-center">
              <div className="bottom-box text-center">
                <div className="nick-bg-armdown"></div>
                <div className="info-box">
                  <strong>{translate('session.common.texts.text_what_to_do_next')}</strong>
                </div>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-xs-12 col-sm-6 col-sm-offset-3">
              <div className="bottom-box text-center">
                <div className="circle-arrow-group">
                  <div className="circle-arrow-right">
                    <div className="car-text text-center"><strong>{translate('session.password_reset.text_check_your_email')}</strong><p>{translate('session.password_reset.text_inbox_or_spam')}</p></div>
                    <i className="car-top-left"></i>
                    <i className="car-bottom-left"></i>
                    <i className="car-middle"></i>
                    <i className="car-right"></i>
                  </div>
                  <div className="circle-arrow-left">
                    <div className="cal-text text-center"><i className="fa fa-check"></i><span>{translate('session.unlock.text_activate_and_set_password')}</span></div>
                    <i className="cal-top-right"></i>
                    <i className="cal-bottom-right"></i>
                    <i className="cal-middle"></i>
                    <i className="cal-left"></i>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-xs-12 col-sm-6 col-sm-offset-3 text-center fs-14">{translate('session.common.hint.hint_checkout_faq')}</div>
          </div>

        </div>
      </div>

    );

  }
}

const mapStateToProps = state => ({
  translate   : getTranslate(state.locale)
});

export default connect(mapStateToProps)(Unlock);



// WEBPACK FOOTER //
// ./src/components/session/unlock/unlock.js